import { useCallback } from "react";
import { __ } from "@jti/fe-common";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
export const useQuizTracking = () => {
    const trackQuizProgress = useCallback(async (step, currentQuestion, selectedAnswer, consentName) => {
        try {
            if (step === 1 && consentName) {
                await dispatchTrackingEvent(TrackingEvents.TrackingSurveyStart, {
                    survey_question: consentName,
                    survey_answer: selectedAnswer ? __("sob.consent.yes") : __("sob.consent.no"),
                });
                return;
            }
            const trackingPayload = {
                survey_question: currentQuestion?.question.title,
                survey_answer: currentQuestion?.possibleAnswers.find((a) => a.id === selectedAnswer)?.localTranslation || "",
                ...(step > 1 && {
                    survey_step_number: `${step}`,
                }),
            };
            await dispatchTrackingEvent(step <= 1 ? TrackingEvents.TrackingSurveyStart : TrackingEvents.TrackingSurveyProgress, trackingPayload);
        }
        catch (error) {
            console.error("Failed to track quiz progress:", error);
        }
    }, []);
    const trackQuizCompletion = useCallback(async () => {
        try {
            await dispatchTrackingEvent(TrackingEvents.TrackingSurveyCompletion);
        }
        catch (error) {
            console.error("Failed to track quiz completion:", error);
        }
    }, []);
    return {
        trackQuizProgress,
        trackQuizCompletion,
    };
};
//# sourceMappingURL=useQuizTracking.js.map